import { Component } from 'react';
import adBlocker from 'just-detect-adblock'

export class AdBlockDetect extends Component {

    state = {
        detected: false
    };

    componentDidMount = () => {
        if(adBlocker.isDetected()) {
            this.setState({
                detected: true
            });
        }
    };

    render = () => this.state.detected ? this.props.children : null
}

